import {
  AsyncPipe,
  NgTemplateOutlet,
} from '@angular/common';
import {
  NgModule,
} from '@angular/core';
import {
  MatButtonModule,
} from '@angular/material/button';
import {
  MatDialogModule,
} from '@angular/material/dialog';
import {
  BoardingPassesStoreModule,
} from '@des/store/boarding-passes';
import {
  CheckInPaymentRecordsStoreModule,
} from '@des/store/check-in-payment-records';
import {
  JourneyUnpaidItemsStoreModule,
} from '@des/store/journey-unpaid-items';
import {
  JourneysStoreModule,
} from '@des/store/journeys';
import {
  MessagesBaseStoreModule,
} from '@des/store/messages';
import {
  RegulatoryDetailsStoreModule,
} from '@des/store/regulatory-details';
import {
  SeatmapsStoreModule,
} from '@des/store/seatmaps';
import {
  FormErrorMessagesStoreModule,
} from '@o3r/forms';
import {
  LocalizationModule,
} from '@o3r/localization';
import {
  DeeplinkReturnURLModule,
} from '@refx/shared-services';
import {
  UiStatusStoreModule,
} from '@refx/shared-store';
import {
  CancelCheckinStoreModule,
  CurrentJourneyBaggageStoreModule,
  MultiLegSeatSelectionsStoreModule,
  SsciPaymentStatusStoreModule,
} from '@refx/ssci-store';
import {
  ExitFlowComponent,
} from './exit-flow.component';

@NgModule({
  imports: [
    AsyncPipe,
    NgTemplateOutlet,
    MatButtonModule,
    LocalizationModule,
    JourneysStoreModule,
    FormErrorMessagesStoreModule,
    MessagesBaseStoreModule,
    BoardingPassesStoreModule,
    SeatmapsStoreModule,
    CancelCheckinStoreModule,
    RegulatoryDetailsStoreModule,
    SsciPaymentStatusStoreModule,
    CheckInPaymentRecordsStoreModule,
    JourneyUnpaidItemsStoreModule,
    CurrentJourneyBaggageStoreModule,
    UiStatusStoreModule,
    DeeplinkReturnURLModule,
    MultiLegSeatSelectionsStoreModule,
    MatDialogModule
  ],
  declarations: [ExitFlowComponent],
  exports: [ExitFlowComponent],
  providers: []
})
export class ExitFlowModule {}
